export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-view-quilt',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['DATABASE']
      },
      //master tab
      {
        _name: 'CSidebarNavDropdown',
        name: 'Master',
        route: '/master',
        icon: 'cil-storage',
        items: [
          {
            name: 'Category Sermon',
            to: '/master/categorysermon'
          },
          {
            name: 'Discover',
            to: '/master/discover'
          },
          {
            name: 'Article Content',
            to: '/master/article'
          },
          {
            name: 'Article Category',
            to: '/master/article-category'
          },
          {
            name: 'Link Content',
            to: '/master/link'
          },
          {
            name: 'Section',
            to: '/master/section'
          },
        ]
      },
    ]
  }
]